module.exports = __webpack_public_path__ + "img/course-8.bb66fa85.png";